import React, { useState } from "react";
import axios from "axios";
import { Lock, LogIn } from "lucide-react";
import { API, setToken, errText } from "../../lib/adminApi";
import { BRAND } from "../../data/site";

export const AdminLogin = ({ onSuccess }) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const { data } = await axios.post(`${API}/auth/login`, { email, password });
      setToken(data.access_token);
      onSuccess(data.user);
    } catch (err) {
      setError(errText(err?.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  const cls = "w-full bg-white/[0.04] border border-white/10 rounded-xl px-4 py-3 text-white placeholder:text-slate-500 text-sm focus:outline-none focus:border-brand-orange focus:ring-1 focus:ring-brand-orange";

  return (
    <div className="min-h-screen bg-navy-deep flex items-center justify-center px-4">
      <form onSubmit={submit} data-testid="admin-login-form" className="glass rounded-3xl p-8 md:p-10 w-full max-w-md">
        <div className="flex items-center gap-3 mb-8">
          <img src="/assets/ats-logo.png" alt={`${BRAND.name} logo`} className="h-12 w-12 rounded-full" />
          <div>
            <p className="font-head text-white font-semibold">{BRAND.name}</p>
            <p className="font-mono text-[10px] tracking-wider uppercase text-slate-500">Talent Inbox · Admin</p>
          </div>
        </div>
        <div className="space-y-4">
          <input data-testid="admin-email" type="email" autoComplete="username" placeholder="Admin email" value={email} onChange={(e) => setEmail(e.target.value)} className={cls} required />
          <input data-testid="admin-password" type="password" autoComplete="current-password" placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)} className={cls} required />
        </div>
        {error && <p data-testid="admin-login-error" className="text-red-400 text-sm mt-4">{error}</p>}
        <button type="submit" disabled={loading} data-testid="admin-login-submit" className="btn-primary w-full justify-center mt-6 disabled:opacity-60">
          {loading ? "Signing in…" : "Sign in"} <LogIn size={16} />
        </button>
        <p className="text-slate-500 text-xs mt-6 flex items-center gap-2"><Lock size={12} /> Restricted to authorized ATS personnel.</p>
      </form>
    </div>
  );
};

export default AdminLogin;
